<svelte:options runes={true} />

<script lang="ts">
	import { getContext, type Snippet } from "svelte";
	import { isFeatureEnabled } from "#lib/featureFlags.js";
	import type { JwtPayload } from "#lib/jwt.js";
	import type { Client } from "@optimizely/optimizely-sdk";
	import type { Writable } from "svelte/store";

	interface Props {
		children?: Snippet;
		fallback?: Snippet;
		flag: string;
		attrs?: Record<string, string>;
	}

	const flags: Client = getContext("flags");
	const claims: Writable<JwtPayload> = getContext("claims");

	const { children, fallback, flag, attrs }: Props = $props();
	const shouldRender = $derived(isFeatureEnabled(flags, flag, $claims, attrs));
</script>

{#if shouldRender}
	{@render children?.()}
{:else}
	{@render fallback?.()}
{/if}
